<script setup>
const props = defineProps({
  block: {
    type: Object,
    default: () => ({}),
  },
  type: {
    type: String,
    default: '',
  },
  imageShape: {
    type: String,
    default: '',
  },
  maxContent: {
    type: Boolean,
    default: false,
  },
})

const computedClass = computed(() => {
  if (
    props.type === 'reverse in-detail-page' ||
    props.type === 'default in-detail-page'
  ) {
    return {
      'row-130-25 p-bottom-xl-1 p-top-xl-1': true,
    }
  }
  return {
    'row-400-25 p-bottom-xl-1': props.type === 'default',
    'row-270-25': props.type === 'reverse',
    'p-top-xxxxl-1': props.type === 'reverse' || props.type === 'default',
  }
})
</script>

<template>
  <div class="img-text max" :class="computedClass">
    <div :class="['container', type, { 'max-content': maxContent }]">
      <!-- eslint-disable vue/no-v-html -->
      <div class="left">
        <DefaultPicture
          :image="{ landscape: block.landscape.responsiveImage }"
          :lazy-load="true"
          alt="Istituto Canossiano"
          :class="imageShape"
        />
      </div>
      <div class="right">
        <div class="title-base" v-html="block.titolo" />
        <div v-if="block.immagineDecorativa" class="decoration-img-container">
          <DecorationImage
            :image="block.immagineDecorativa.immagine"
            :type="block.immagineDecorativa.titolo"
          />
        </div>
        <div class="text-s-1-b" v-html="block.testo" />
        <DefaultBtn
          v-if="block.cta?.file"
          :text="block.cta.testo"
          :content="block.cta.file.url"
          class="button-round-1 with-icon is-orange"
        />
        <DefaultLink
          v-if="block.cta?.link"
          class="icon-link text-custom is-semi-bold"
          :text="block.cta.testo"
          :content="block.cta.link"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ImgText',
}
</script>

<style lang="scss">
@import './style.scss';
</style>
